const DEFAULT_READ_ATTEMPTS = 3;

export const PIN_FAILED_MESSAGE =
  "Your device stopped sharing this photo before we could save it. Please remove it and choose it again.";

/**
 * Read a Blob's bytes, retrying transient failures.
 *
 * Chrome on Android hands the page File objects backed by photo-picker
 * content URIs whose read grant can lapse a few seconds later: reads then
 * throw NotReadableError ("permission problems that have occurred after a
 * reference to a file was acquired") and a raw-file PUT dies as a "network
 * error". A short retry rides out a momentary hiccup; a dead handle stays
 * dead and the caller surfaces PIN_FAILED_MESSAGE.
 */
export async function readFileBytesWithRetry(blob, attempts = DEFAULT_READ_ATTEMPTS) {
  let lastErr;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      return await blob.arrayBuffer();
    } catch (err) {
      lastErr = err;
      if (attempt < attempts) {
        await new Promise((r) => setTimeout(r, 250 * attempt));
      }
    }
  }
  throw lastErr || new Error('read failed');
}
